import { render, staticRenderFns } from "./WPBaseSelect.vue?vue&type=template&id=14b0bc90"
import script from "./WPBaseSelect.vue?vue&type=script&lang=ts"
export * from "./WPBaseSelect.vue?vue&type=script&lang=ts"
import style0 from "./WPBaseSelect.vue?vue&type=style&index=0&id=14b0bc90&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports